<template lang="pug">
section.Category.pa2-m.pa4-l
  header.Category-Header
    h2.f4.f3-l {{ model.name }}
    p.f5.lh-copy.measure.gray(v-html='model.description')

  .Category-Body
    component(
      :is='componentType',
      :selected-option-index='selectedOptionIndex',
      v-model='model'
    )
</template>

<script>

import BookartSelect from './BookartSelect/BookartSelect'
import BookartToggle from './BookartToggle/BookartToggle'
import BookartToggleThumbnail from './BookartToggleThumbnail/BookartToggleThumbnail'

const componentTypes = ['bookart-toggle', 'bookart-toggle-thumbnail']

export default {
  name: 'bookart-category',
  props: ['value', 'selectedOptionIndex'],
  data () {
    return {
      componentType: componentTypes[this.value.type]
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  components: {
    BookartSelect,
    BookartToggle,
    BookartToggleThumbnail,
  },
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// BookartCategory.vue?c8315fae